import { AddressFormikType, AddressInputKey } from "@modules/address/addressFormikType"
import { word } from "@modules/core/utils/i18n"
import * as Yup from "yup"

export type DetailedMemberInputKey =
  | "firstname"
  | "lastname"
  | "username"
  | "birthDate"
  | "email"
  | "phoneNumber"
  | "subscriptionId"
  | "emergencyInformation"
  | "note"
  | AddressInputKey

export type MemberInputKey =
  | "firstname"
  | "lastname"
  | "name"
  | "present"
  | "inscriptionDate"
  | "status"
  | "activeOffer"
  | "lastVisit"
  | "assignedCoach"
  | "note"
  | "noshow"

export type MemberDetailsFormikType = {
  firstname: string
  lastname: string
  username?: string
  birthDate?: Date
  phoneNumber: string
  email: string
  emergencyInformation: string
  note: string
  subscriptionId?: string
} & AddressFormikType

export type MemberDaytoDayFormikType = {
  note: string
}

export function memberDaytoDayFormikValidationSchema(oldNote: string) {
  return Yup.object({
    note: Yup.string().test("note", word("box.member.table.dayToDay.noteError"), (value) => value !== oldNote),
  })
}
